export default __webpack_public_path__ + "static/media/gameStayDay.3d6ece71.jpg";